export const LINE_ITEMS_TEST_IDS = {
  list: 'list',
  listItem: 'list-item',
};

export const getListItemTestId = (name: string) => {
  const displayName = name.trim().toLowerCase().replace(/\s+/g, '-');

  return `${displayName}-${LINE_ITEMS_TEST_IDS.listItem}`;
};
